import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/SEOCopyParagraph/SEOCopyParagraph.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/general/components/Breadcrumbs/Breadcrumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/app/src/general/components/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/src/general/components/Image/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MicrocopyComponent"] */ "/app/src/general/components/Microcopy/MicrocopyComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YoutubeVideo"] */ "/app/src/general/components/YoutubeVideo/YoutubeVideo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/plp/components/PlpFilters/PlpFiltersSortWrapper.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["PlpFiltersTrigger"] */ "/app/src/plp/components/PlpFiltersTrigger/PlpFiltersTrigger.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/plp/components/PlpHeader/PlpHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["PlpSort"] */ "/app/src/plp/components/PlpSort/PlpSort.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultsDynamic"] */ "/app/src/plp/components/Results/ResultsDynamic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResultsHeadingDynamic"] */ "/app/src/plp/components/Results/ResultsHeadingDynamic.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlpContextTotalResults"] */ "/app/src/stores/plpStore.tsx");
